module.exports = __webpack_public_path__ + "static/media/camera.f2ef7ebf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/camera.svg
// module id = 611
// module chunks = 0